<template>
   <div style="background-color: #EFEFEF; max-wdith:1280px;">
        <Header :viewDeals="viewDeals" />
        
		<ModuleMenu 
			v-if="loadMenu"
			:moduleKey="$route.params.mid"
			:projectId="project_id"
			@quickViewDeals="viewDeals = !viewDeals" />


        <v-container class="container_width pb-12">
          <h2>Ok! Here's how to express interest</h2>

          <v-row>
            <v-col>
              <div>
                <img class="image" src="../assets/imgBuyerProfile@2x.png"/>
              </div>
              <span class="steps">Step 1</span>
              <div class="titles">Complete Buyer Profile</div>
              <div class="step_content">
                Answer questions about your practice and previous acquisitions. You'll only have to do this application once.
              </div>
            </v-col>

            <v-col>
              <div>
                <img class="image" src="../assets/imgUSAw-listings@2x.png"/>
              </div>
              <span class="steps">Step 2</span>
              <div class="titles">Express Interest</div>
              <div class="step_content">
                Once you've submitted a buyer profile, find a practice you want to acquire and express interest.
              </div>
            </v-col>

            <v-col>
              <div>
                <img class="image" src="../assets/ImgConversation@2x.png"/>
              </div>
              <span class="steps">Step 3</span>
              <div class="titles">Buyer Profile Status</div>
              <div class="step_content">
                Our listing team reviews your application. If you're a good fit, we will reach out with next steps. If not, we'll keep your application on file for future practices.
              </div>
            </v-col>
          </v-row>

          <div class="spacer"/>

          <v-row v-if="loadMenu">
              <router-link :to="`/module_questionnaire/buyer/${project_id}`" push class="continue-to-buyer-profile-button">
                <button class="continue-to-buyer-profile-button" >Continue to Buyer Profile</button>
              </router-link>
          </v-row>

          <v-row>
            <span class="questions">
              <p>Questions: Call us at:
                <br>(503) 427-9910</p>
            </span>
          </v-row>

        </v-container>
   </div>
</template>


<script>
    import axios from 'axios'
    import appUrls from '../helpers/environment'

    import Header from './Header'
    import ModuleMenu from './ModuleMenu'

    export default {
        name: 'HowToExpressInterest',
        
		components: {
			Header,
			ModuleMenu,
        },
        
		data () {
			return {
				readyToLoad: false,
				readyToLoadTeam: false,
				loadMenu: false,
				mod_info: [],
				viewDeals: false,
				project_id: '',
				authUser: {
					id: String,
					is_secondary: Boolean
				}
			}
        },

		created() {
      document.title = 'SRG myCompass: How To Express Interest'
			this.getProjectId()
		},

		mounted() {
			// this.getProjectId()
        },

        methods: {
        	checkUser: async function () {
				await axios.get(`${appUrls.api}/api/user_check`, {
					headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
				})
				.then( res => {
					if(res.data.outcome) {    
						this.authUser.id = res.data.user_data.id
						this.authUser.is_secondary = res.data.user_data.is_secondary
					} else {
						console.log(res.data.message)
					}
				})
				.catch(function (error) {
					console.log(error);
				});
          	},

          	getProjectId: async function () {
				await this.checkUser()
				await axios.get(`${appUrls.api}/api/module_projects/${this.$route.params.mid}/${this.authUser.id}/${this.authUser.is_secondary}`, {
					headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
				})
				.then( res => {
					if(res.data.outcome){
						this.project_id = res.data.project_data.project_id;
						this.loadMenu = true
					}
				})
				.catch(function (error) {
					console.log(error);
				});
          	},

			getModuleInfo: function () {
				axios.get(`${appUrls.api}/api/module_info/buyer`, {
					headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
				})
				.then( res => {
					//console.log(res.data)
					if(res.data.outcome){
						this.mod_info = res.data.info;
						setTimeout(() => {
							this.readyToLoad = true;
							if( this.mod_info.srg_team != null) this.readyToLoadTeam = true;
						}, 500);
					}
				})
				.catch(function (error) {
					console.log(error);
				});
			}
        }
    }
</script>


<style scoped>

.questions {
  text-align: center;
  margin: auto;
  margin-top: 25px;
}

.spacer {
  height: 100px;
}

.steps {
  font-size: 18px;
  font-family: 'Sansation', sans-serif;
}

.titles {
  font-size: 24px;
  font-family: 'Sansation', sans-serif;
}

.image {
  max-width: 100%;
  height: 150px;
  margin-bottom: 25px;
  margin-top: 50px;
}

.step_content {
  font-size: 16px;
  font-family: 'AvenirBook', Arial, Helvetica, sans-serif;
}

.pb-12 {
  color: rgb(98,98,98) !important;
}

.continue-to-buyer-profile-button {
  padding: 10px 25px;
  background: #97C131;
  border-radius: 5px;
  color: white;
  text-transform: uppercase;
  font-family: 'SansationBold', sans-serif;
  outline:none;
  margin: auto;
}
    .v-input {
        opacity: 0.9;
        color: blue;
    }
    .min_height {
        min-height: 70vh;
    }
    label.v-label {
        color: blue !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/HowToExpressInterest.vue